import React from 'react';
import './Contact.css';
import portfolioData from '../data/portfolio.json';

const Contact = () => {
  const { personalInfo } = portfolioData;

  return (
    <section id="contact" className="contact">
      <h2>Get In Touch</h2>
      <div className="contact-content">
        <div className="contact-intro">
          <p>
            I'm currently available for exciting opportunities and collaborations. 
            Whether you have a project in mind or just want to connect, feel free to reach out!
          </p>
        </div>
        
        <div className="contact-methods">
          <div className="contact-card">
            <div className="contact-icon">📧</div>
            <div className="contact-details">
              <h3>Email</h3>
              <a href={`mailto:${personalInfo.email}`}>{personalInfo.email}</a>
            </div>
          </div>
          
          <div className="contact-card">
            <div className="contact-icon">📱</div>
            <div className="contact-details">
              <h3>Phone</h3>
              <a href={`tel:${personalInfo.phone}`}>{personalInfo.phone}</a>
            </div>
          </div>
          
          <div className="contact-card">
            <div className="contact-icon">📍</div>
            <div className="contact-details">
              <h3>Location</h3>
              <p>{personalInfo.location}</p>
            </div>
          </div>
        </div>

        <div className="contact-cta">
          <a href={`mailto:${personalInfo.email}?subject=Project Inquiry`} className="btn-contact">
            Send Me an Email
          </a>
        </div>
      </div>
      
      <footer className="footer">
        <p>© 2025 {personalInfo.name}. Built with React.</p>
      </footer>
    </section>
  );
};

export default Contact;
